import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SnackbarService } from '@core/snackBar.notification.service';
import { environment } from '@env/environment';
import { map, Observable } from 'rxjs';

export interface UserAccessTokenResponse {
  token: string;
  expiresAt: string;
  status: 'success';
}

interface TokenMissingResponse {
  token: '';
  expiresAt: null;
  status: 'no_token_provided';
}

interface TokenUnauthorizedResponse {
  status: 'unauthorized';
}

type TokenResponse = UserAccessTokenResponse | TokenMissingResponse | TokenUnauthorizedResponse;

@Injectable({
  providedIn: 'root'
})
export class UserAccessService {
  constructor(
    private http: HttpClient,
    private snackbarService: SnackbarService
  ) { }

  getToken$(): Observable<UserAccessTokenResponse> {
    return this.http.get<TokenResponse>(environment.adminUrl + '/user-access/token').pipe(
      map((data) => {
        const noTokenErrorMessage = 'No token provided';
        const unauthorizedErorMessage = 'Unauthorized access';
        switch (data.status) {
          case 'success': return data;
          case 'no_token_provided': this.snackbarService.showError(noTokenErrorMessage);
            throw new Error(noTokenErrorMessage);
          case 'unauthorized': this.snackbarService.showError(unauthorizedErorMessage);
            throw new Error(unauthorizedErorMessage);
        }
      })
    );
  }
}
